import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { DonationComponent } from './donation.component';


const routes: Routes = [
  {
    path: 'donation',
    component: DonationComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class DonationRoutingModule {}
